import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("heo_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler → clear session and redirect to /login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("heo_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const AuthAPI = {
  login: (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  changePassword: (current_password, new_password) =>
    api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
};

export const UsersAPI = {
  list: () => api.get("/users").then((r) => r.data),
  create: (data) => api.post("/users/subcontractor", data).then((r) => r.data),
  toggleActive: (id) => api.patch(`/users/${id}/toggle-active`).then((r) => r.data),
  resetPassword: (id) => api.post(`/users/${id}/reset-password`).then((r) => r.data),
  remove: (id) => api.delete(`/users/${id}`).then((r) => r.data),
};

export const InvoiceAPI = {
  list: (ownerId) =>
    api
      .get("/invoices", { params: ownerId ? { owner_id: ownerId } : {} })
      .then((r) => r.data),
  get: (id) => api.get(`/invoices/${id}`).then((r) => r.data),
  create: (data) => api.post("/invoices", data).then((r) => r.data),
  update: (id, data) => api.put(`/invoices/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/invoices/${id}`).then((r) => r.data),
  setStatus: (id, status) =>
    api.patch(`/invoices/${id}/status`, { status }).then((r) => r.data),
  stats: (ownerId) =>
    api
      .get("/invoices/stats", { params: ownerId ? { owner_id: ownerId } : {} })
      .then((r) => r.data),
};

export const SettingsAPI = {
  get: () => api.get("/settings").then((r) => r.data),
  update: (data) => api.put("/settings", data).then((r) => r.data),
};

export const ProfileAPI = {
  get: () => api.get("/profile").then((r) => r.data),
  update: (data) => api.put("/profile", data).then((r) => r.data),
  getFor: (userId) => api.get(`/users/${userId}/profile`).then((r) => r.data),
};

export const ReceiptAPI = {
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api
      .post("/receipts", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  // Returns a browser-usable blob URL for inline display
  previewUrl: async (id) => {
    const r = await api.get(`/receipts/${id}/download`, { responseType: "blob" });
    return URL.createObjectURL(r.data);
  },
  // Returns raw blob (for forcing a download)
  downloadBlob: async (id) => {
    const r = await api.get(`/receipts/${id}/download`, { responseType: "blob" });
    return r.data;
  },
};

export default api;
